import React from 'react'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { WaitingCell } from 'src/components/document-review/queue/WaitingCell'
import type { McReviewQueueRow } from 'src/interfaces/mcDocumentReview'
import { parseReviewDate, resolveMcDisplayName } from 'src/utils/documentReviewList'
import { mcQueueHeaderTitles } from './constants'
import { McQueueFields } from './enums'

/**
 * A factory rather than a constant: the master-contractor name is joined from the customer list
 * at runtime. Memoise the result on `customerNameById` at the call site so the grid does not see
 * a new column array on every render.
 */
export const buildMcQueueColumns = (
  customerNameById: Record<string, string>,
): Array<GridColDef<McReviewQueueRow>> => {
  return [
    {
      field: McQueueFields.partnerId,
      headerName: mcQueueHeaderTitles[McQueueFields.partnerId],
      flex: 3,
      minWidth: 200,
      sortable: true,
      hideable: false,
      display: 'flex',
      valueGetter: (value, row) => {
        return resolveMcDisplayName(row.partnerId, customerNameById)
      },
      renderCell: (params: GridRenderCellParams<McReviewQueueRow>) => {
        return (
          <Typography variant="body2" css={tw`truncate`}>
            {resolveMcDisplayName(params.row.partnerId, customerNameById)}
          </Typography>
        )
      },
    },
    {
      field: McQueueFields.type,
      headerName: mcQueueHeaderTitles[McQueueFields.type],
      flex: 2,
      minWidth: 160,
      sortable: true,
      display: 'flex',
    },
    {
      field: McQueueFields.status,
      headerName: mcQueueHeaderTitles[McQueueFields.status],
      flex: 2,
      minWidth: 160,
      sortable: true,
      display: 'flex',
    },
    {
      field: McQueueFields.finishedAt,
      headerName: mcQueueHeaderTitles[McQueueFields.finishedAt],
      flex: 1,
      minWidth: 120,
      sortable: true,
      display: 'flex',
      valueGetter: (value, row) => {
        return parseReviewDate(row.finishedAt ?? null)?.toMillis() ?? 0
      },
      renderCell: (params: GridRenderCellParams<McReviewQueueRow>) => {
        return <WaitingCell finishedAt={params.row.finishedAt ?? null} />
      },
    },
  ]
}
